export default {
      id: "panic-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#panic",
      toString: function () {
        return this.url;
      }
    }